import React, {Component, PropTypes} from 'react'
import {Col, Modal, Row} from "react-bootstrap";
import {hasUserRight, showAxiosError} from "../../helper/helper";
import {UserRightsEnum} from "../../helper/enums";
import {showDbs, showSmmRepeatDay} from "../../helper/permission";
import {request} from "../../helper/APIUtils";
import PrintViewer from "./PrintViewer";

class MediaViewer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			changeSize: false,
			printViewer:false,
		};
		this.isOpen = this.isOpen.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.openModal = this.openModal.bind(this);
		this.resize = this.resize.bind(this);
		this.printDocument = this.printDocument.bind(this);
		this.closePrintModal = this.closePrintModal.bind(this);

	}

	isOpen() {
		this.props.listener();
	}

	openModal() {
		this.setState({modal: true});
	}

	closeModal() {
		this.setState({modal: false});
	}

	resize() {
		if (this.state.changeSize == false) {
			this.setState({changeSize: true});
		} else {
			this.setState({changeSize: false});
		}

	}

	printDocument(){
		let self = this;
		const location = self.props.location;
		let params ={
			url:"/" + location + "/toLabelPrinted",
			method:"post",
			data:{
					documentUuid: self.props.selectedItem.documentUuid,
					year: self.props.year,
					month: self.props.month
			}
		}
		request(params).then((response)=>{
			self.setState({printViewer:true});
			self.props.refreshListAfterPrinting();
		}).catch(error=>{
			showAxiosError(error);
		})
	}

	downloadInboxPdf() {
		let documentUuid = this.props.selectedItem.documentUuid;
		let year = this.props.year;
		let month = this.props.month;
		this.downloadDocument(`/inbox/downloadMedia/pdf`, documentUuid, year, month);
	}

	downloadOutboxPdf() {
		let documentUuid = this.props.selectedItem.documentUuid;
		let year = this.props.year;
		let month = this.props.month;
		this.downloadDocument(`/outbox/downloadMedia/pdf`, documentUuid, year, month);
	}

	downloadDespatchInboxPdf() {
		let documentUuid = this.props.selectedItem.documentUuid;
		let year = this.props.year;
		let month = this.props.month;
		this.downloadDocument(`/despatchInbox/downloadMedia/pdf`, documentUuid, year, month);
	}

	downloadDespatchOutboxPdf() {
		let documentUuid = this.props.selectedItem.documentUuid;
		let year = this.props.year;
		let month = this.props.month;
		this.downloadDocument(`/despatchOutbox/downloadMedia/pdf`, documentUuid, year, month);
	}

	downloadEArchivePdf() {
		let documentUuid = this.props.selectedItem.documentUuid;
		let year = this.props.year;
		let month = this.props.month;
		this.downloadDocument(`/eArchive/downloadMedia/pdf`, documentUuid, year, month);
	}
	downloadArchiveVoucherPdf() {
		let documentUuid = this.props.selectedItem.documentUuid;
		let year = this.props.year;
		let month = this.props.month; 
		this.downloadDocument(`/archiveVoucher/downloadMedia/pdf`, documentUuid, year, month);
	}
	

	downloadDocument(endpoint, documentUuid, year, month) {
		let params = {
			url: endpoint,
			method: "post",
			responseType: 'arraybuffer',
			data: {
				documentUuid: documentUuid,
				year: year,
				month: month
			}
		};

		request(params)
			.then(function (response) {
				let contentDisposition = response.headers["content-disposition"];
				let fileName = "document.pdf";
				if (contentDisposition) {
					let matches = contentDisposition.match(/filename="(.+?)"/);
					if (matches) {
						fileName = matches[1];
					}
				}

				let blob = new Blob([response.data], { type: response.headers["content-type"] });
				let url = window.URL.createObjectURL(blob);

				const link = document.createElement("a");
				link.href = url;
				link.download = fileName;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				window.URL.revokeObjectURL(url);
			})
			.catch(function (error) {
				if (error.response === undefined) {
					showAxiosError({ message: "Şuan işleminiz gerçekleştirilemiyor." });
				} else {
					let enc = new TextDecoder("utf-8");
					showAxiosError({ message: enc.decode(error.response.data) });
				}
			});
	}


	closePrintModal(){
		let self = this;
		self.setState({printViewer:false})
	}

	render() {

		return (

				<div>
					<Modal show={this.props.modal}
						   animation={false}
						   toggle={this.isOpen}
						   modalTransition={{timeout: 700}}
						   dialogClassName="modal-90w"
						   size={this.state.changeSize ? "xxl" : "xl"}
						   backdropTransition={{timeout: 1300}}
						   aria-labelledby="example-custom-modal-styling-title"
						   backdrop="static">
						<Modal.Header>
							<Modal.Title id="example-custom-modal-styling-title">
								<div className=".col-12 .col-md-8">
									<div className=".col-6 .col-md-4" style={{top: "0"}}>
										<p style={{display: "inline", fontWeight: 700}}>{this.props.title || ""}</p>

										<button type="button"
												style={this.state.changeSize ? {
													zIndex: "1400",
													left: "95%",
													top: "3%"
												} : {zIndex: "1400", left: "92%", top: "4%"}}
												onClick={this.resize}
												id="resize"
												className="close pull-right"
												title={this.state.changeSize ? "Daralt" : "Genişlet"}
												aria-label="Daralt">
										<span aria-hidden="true"><i
												className={this.state.changeSize ? "fas fa-compress" : "fas fa-expand"}
												style={{fontSize: "47%"}}/></span>
										</button>
										<button type="button"
												style={this.state.changeSize ? {
													zIndex: "1400",
													left: "97%",
													top: "4%"
												} : {zIndex: "1400", left: "95%", top: "5%"}}
												onClick={this.isOpen}
												id="close"
												className="close pull-right"
												title="Kapat"
												aria-label="Kapat">
											<span aria-hidden="true">×</span>
										</button>

									</div>
								</div>
							</Modal.Title>

						</Modal.Header>
						<Modal.Body style={this.state.changeSize ? {padding: "0", left: "1px"} : {
							padding: "0",
							// height: "611px"
						}}>
							{(this.props.selectedItem && this.props.currentUser && this.props.location === 'inbox') &&
							<Row className='viewer-button-row'>
								{((this.props.selectedItem.documentProfile === "TICARIFATURA" || this.props.selectedItem.documentProfile === "HKS") &&
										this.props.selectedItem.responseValidationState !== 1 &&
										this.props.selectedItem.responseValidationState !== 2) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.answerFromViewer(this.props.selectedItem)}>Faturayı
										Cevapla</a>
								</Col>}


								{(this.props.selectedItem.invoiceTypeCode !== "IADE" && this.props.selectedItem.responseCode !== "RED") &&
								hasUserRight(UserRightsEnum.invoice.respondIncoming, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.directReturnFromViewer(this.props.selectedItem)}>Doğrudan
										İade</a>
								</Col>}

								{hasUserRight(UserRightsEnum.invoice.viewIncoming, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.downloadMedia(this.props.selectedItem, "xml", this.props.selectedIndex)}>Fatura
										XML İndir</a>
								</Col>}

								{(this.props.selectedItem.documentProfile === "TICARIFATURA" && this.props.selectedItem.responseDocumentUuid !== "OTOMATIK KABUL" && this.props.selectedItem.responseDocumentUuid) &&
								hasUserRight(UserRightsEnum.invoice.viewIncoming, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.downloadMedia(this.props.selectedItem, "response_xml")}>Uyg.Ynt.XML İndir</a>
								</Col>}

								{hasUserRight(UserRightsEnum.invoice.viewIncoming, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.sendEmailFromViewer(this.props.selectedItem)}>e-Posta
										Gönder</a>
								</Col>}

								{hasUserRight(UserRightsEnum.invoice.viewIncoming, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.createExtCustFromViewer(this.props.selectedItem)}>Cari
										Oluştur</a>
								</Col>}
								{hasUserRight(UserRightsEnum.invoice.viewIncoming, this.props.currentUser) &&
									<Col xs='6' md='4' lg='2'>
										<a className='btn-info' style={{ marginLeft: "-20px" }} onClick={()=> this.printDocument()} >Pdf Yazdır</a>
									</Col>
								}
								{hasUserRight(UserRightsEnum.invoice.viewIncoming, this.props.currentUser) &&
									<Col xs='6' md='4' lg='2'>
										<a className='btn-info' style={{ marginLeft: "-50px" }} onClick={() => this.downloadInboxPdf()} >Pdf İndir</a>
									</Col>
								}

							</Row>}

							{(this.props.selectedItem && this.props.currentUser && this.props.location === 'tmpInvoice') &&
							<Row className='viewer-button-row'>
								{((this.props.direction === "Out" && (this.props.selectedItem.eState === 1)) || this.props.direction === "Tmp") &&
								((this.props.profileId === "EFATURA") ? hasUserRight(UserRightsEnum.invoice.send, this.props.currentUser) : hasUserRight(UserRightsEnum.earchive.send, this.props.currentUser)) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.handleSend(this.props.selectedItem, this.props.selectedIndex)}>Faturayı
										Gönder</a>
								</Col>}

								{((this.props.profileId === "EFATURA") ? hasUserRight(UserRightsEnum.invoice.update, this.props.currentUser) : hasUserRight(UserRightsEnum.earchive.update, this.props.currentUser))
								|| this.props.profileId !== "depoIade" &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.handleEdit(this.props.selectedItem)}>Faturayı
										Düzenle</a>
								</Col>}

								{((this.props.direction === "Out" && (this.props.selectedItem.eState !== 0)) || this.props.direction === "Tmp") &&
								((this.props.profileId === "EFATURA") ? hasUserRight(UserRightsEnum.invoice.view, this.props.currentUser) : hasUserRight(UserRightsEnum.earchive.view, this.props.currentUser)) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.downloadMedia(this.props.selectedItem, "xml")}>Fatura
										XML İndir</a>
								</Col>}

								{((this.props.profileId === "EFATURA") ? hasUserRight(UserRightsEnum.invoice.delete, this.props.currentUser) : hasUserRight(UserRightsEnum.earchive.delete, this.props.currentUser)) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.handleDelete(this.props.selectedItem)}>Faturayı Sil</a>
								</Col>}
							</Row>}

							{(this.props.selectedItem && this.props.currentUser && this.props.location === 'outbox') &&
							<Row className='viewer-button-row'>
								{((this.props.stateCodes instanceof Object && ((this.props.selectedItem.processState +
										"" + this.props.selectedItem.processResult) in this.props.stateCodes)) &&
										(this.props.stateCodes[this.props.selectedItem.processState +
										"" + this.props.selectedItem.processResult][1] === "F")) &&
								hasUserRight(UserRightsEnum.invoice.update, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.copyEditInvoice(this.props.selectedItem, "edit")}>Faturayı
										Düzenle</a>
								</Col>}

								{hasUserRight(UserRightsEnum.invoice.view, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.downloadMedia(this.props.selectedItem, "xml")}>Fatura
										XML İndir</a>
								</Col>}


								{hasUserRight(UserRightsEnum.invoice.create, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.copyEditInvoice(this.props.selectedItem, "copy")}>Fatura
										Kopyala</a>
								</Col>}

								{this.props.selectedItem.processState >= 100 && hasUserRight(UserRightsEnum.invoice.view, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.sendEmailFromViewer(this.props.selectedItem)}>e-Posta Gönder</a>
								</Col>}

								{(this.props.selectedItem.processState < 180 && this.props.selectedItem.processResult !== 3 && this.props.selectedItem.processResult !== 13 && this.props.selectedItem.isCancelled !== 1) &&
								hasUserRight(UserRightsEnum.invoice.send, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.cancelSendInvoice(this.props.selectedItem)}>Gönderimi İptal Et</a>
								</Col>}

								{(this.props.selectedItem.processState < 180 && this.props.selectedItem.processResult === 13 && this.props.selectedItem.isCancelled === 1) &&
								hasUserRight(UserRightsEnum.invoice.send, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.continueSendInvoice(this.props.selectedItem)}>Gönderime Devam Et</a>
								</Col>}

								{((this.props.selectedItem.processState === 140 && this.props.selectedItem.processResult === 3) ||
										(this.props.selectedItem.processState === 180 && this.props.selectedItem.processResult === 3) ||
										(this.props.selectedItem.processState === 500 && (this.props.selectedItem.processResult === 1181 ||
														// this.props.selectedItem.processResult === 1195 ||
														this.props.selectedItem.processResult === 1162 ||
														this.props.selectedItem.processResult === 1215 ||
														this.props.selectedItem.processResult === 1120 ||
														this.props.selectedItem.processResult === 1130 ||
														this.props.selectedItem.processResult === 1140 ||
														this.props.selectedItem.processResult === 1230 ||
														this.props.selectedItem.processResult === 1160 ||
														this.props.selectedItem.processResult === 1176 ||
														this.props.selectedItem.processResult === 1177 ||
														this.props.selectedItem.processResult === 1180 ||
														this.props.selectedItem.processResult === 2005)
										)) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.reSendInvoice(this.props.selectedItem)}>Tekrar
										Gönder</a>
								</Col>}

								{(this.props.selectedItem.processState === 500 &&
										(this.props.selectedItem.processResult === 1140 ||
											this.props.selectedItem.processResult === 1181 ||
											this.props.selectedItem.processResult === 1171 ||
											this.props.selectedItem.processResult === 1172 ||
											this.props.selectedItem.processResult === 1173 ||
											this.props.selectedItem.processResult === 1174)) &&
								hasUserRight(UserRightsEnum.invoice.update, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.editAlias(this.props.selectedItem)}>Etiketi Düzenle</a>
								</Col>}

								{(this.props.selectedItem.documentProfile === "TICARIFATURA" && this.props.selectedItem.responseDocumentUuid !== "OTOMATIK KABUL" && this.props.selectedItem.responseDocumentUuid) &&
								hasUserRight(UserRightsEnum.invoice.view, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.downloadMedia(this.props.selectedItem, "response_xml")}>Uyg.
										Ynt. XML İndir</a>
								</Col>}
								{hasUserRight(UserRightsEnum.invoice.view, this.props.currentUser) &&
									<Col xs='6' md='4' lg='2'>
										<a className='btn-info' onClick={()=> this.printDocument()} >Pdf Yazdır</a>
									</Col>
								}
								{hasUserRight(UserRightsEnum.invoice.viewIncoming, this.props.currentUser) &&
									<Col xs='6' md='4' lg='2'>
										<a className='btn-info' style={{ marginLeft: "-30px" }} onClick={() => this.downloadOutboxPdf()} >Pdf İndir</a>
									</Col>
								}
							</Row>}

							{(this.props.selectedItem && this.props.currentUser && this.props.location === 'eArchive') &&
							<Row className='viewer-button-row'>
								{this.props.stateCodes instanceof Object && ((this.props.selectedItem.processState +
										"" + this.props.selectedItem.processResult) in this.props.stateCodes) &&
								this.props.stateCodes[this.props.selectedItem.processState + "" + this.props.selectedItem.processResult][1] === "F" &&
								hasUserRight(UserRightsEnum.earchive.update, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.copyEditInvoice(this.props.selectedItem, "edit")}>Faturayı
										Düzenle</a>
								</Col>}

								{hasUserRight(UserRightsEnum.earchive.view, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.downloadMedia(this.props.selectedItem, "xml")}>Fatura
										XML
										İndir</a>
								</Col>}

								{(!this.props.cancelActive || this.props.currentUser.cancelPermission)&& this.props.selectedItem.cancelled !== 1 && this.props.selectedItem.objected !== 1 && !(this.props.selectedItem.processState < 140 && this.props.selectedItem.processResult === 3) &&
								hasUserRight(UserRightsEnum.earchive.update, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.cancelInvoice(this.props.selectedItem)}>Faturayı İptal
										Et</a>
								</Col>}

								{hasUserRight(UserRightsEnum.earchive.create, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.copyEditInvoice(this.props.selectedItem, "copy")}>Fatura
										Kopyala</a>
								</Col>}

								{this.props.selectedItem.processState > 110 && hasUserRight(UserRightsEnum.earchive.view, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.sendEmail(this.props.selectedItem)}>e-Posta Gönder</a>
								</Col>}

								{this.props.selectedItem.cancelled === 1 && this.props.selectedItem.cancelReportNo === null &&
								hasUserRight(UserRightsEnum.earchive.update, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.revertCancelInvoice(this.props.selectedItem)}>Fatura
										İptalini Geri Al</a>
								</Col>}

								{hasUserRight(UserRightsEnum.earchive.view, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={()=> this.printDocument()} >Pdf Yazdır</a>
								</Col>
								}
								{hasUserRight(UserRightsEnum.earchive.view, this.props.currentUser) &&
									<Col xs='6' md='4' lg='2'>
										<a className='btn-info'  onClick={() => this.downloadEArchivePdf()} >Pdf İndir</a>
									</Col>
								}
							</Row>}

							{(this.props.selectedItem && this.props.currentUser && (this.props.location === 'tmpExpenseNote' || this.props.location === 'newExpenseNote')) &&
							<Row className='viewer-button-row'>
								{this.props.stateCodes instanceof Object && ((this.props.selectedItem.processState +
										"" + this.props.selectedItem.processResult) in this.props.stateCodes) &&
								this.props.stateCodes[this.props.selectedItem.processState + "" + this.props.selectedItem.processResult][1] === "F" &&
								hasUserRight(UserRightsEnum.expenseNote.update, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.copyEditInvoice(this.props.selectedItem, "edit")}>Pusulayı
										Düzenle</a>
								</Col>}

								{hasUserRight(UserRightsEnum.expenseNote.view, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.downloadMedia(this.props.selectedItem, "xml")}>Pusula
										XML
										İndir</a>
								</Col>}

								{this.props.selectedItem.cancelled !== 1 && !(this.props.selectedItem.processState < 140 && this.props.selectedItem.processResult === 3) &&
								this.props.location !== 'tmpExpenseNote' && hasUserRight(UserRightsEnum.expenseNote.update, this.props.currentUser)  &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.cancelInvoice(this.props.selectedItem)}>Pusulayı İptal
										Et</a>
								</Col>}

								{hasUserRight(UserRightsEnum.expenseNote.create, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.copyEditInvoice(this.props.selectedItem, "copy")}>Pusula
										Kopyala</a>
								</Col>}

								{this.props.selectedItem.processState > 110 && hasUserRight(UserRightsEnum.expenseNote.view, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.sendEmail(this.props.selectedItem)}>e-Posta Gönder</a>
								</Col>}

								{this.props.selectedItem.cancelled === 1 && this.props.selectedItem.cancelReportNo === null &&
								hasUserRight(UserRightsEnum.expenseNote.update, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.revertCancelInvoice(this.props.selectedItem)}>Pusula
										İptalini Geri Al</a>
								</Col>}
							</Row>}

							{(this.props.selectedItem && this.props.currentUser && (this.props.location === 'voucher' || this.props.location === 'exchange')) &&
							<Row className='viewer-button-row'>
								{(this.props.stateCodes instanceof Object && ((this.props.selectedItem.processState + ""
										+ this.props.selectedItem.processResult) in this.props.stateCodes) &&
								this.props.stateCodes[this.props.selectedItem.processState +
								"" + this.props.selectedItem.processResult][1] === "F" &&
								hasUserRight((this.props.documentType === "MUSTAHSILMAKBUZ") ? UserRightsEnum.voucher.mmUpdate :
									(this.props.documentType === "SERBESTMESLEKMAKBUZ" ? UserRightsEnum.voucher.smmUpdate : UserRightsEnum.exchange.update), this.props.currentUser) && this.props.documentType !== "RECEIPT") &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.copyEditVoucher(this.props.selectedItem, "edit")}>Makbuz Düzenle</a>
								</Col>}

								{hasUserRight((this.props.documentType === "MUSTAHSILMAKBUZ") ? UserRightsEnum.voucher.mmView :
									(this.props.documentType === "SERBESTMESLEKMAKBUZ" ? UserRightsEnum.voucher.smmView : UserRightsEnum.exchange.view), this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.downloadMedia(this.props.selectedItem, "xml")}>Makbuz
										XML İndir</a>
								</Col>}

								{(this.props.documentType !== "RECEIPT" && this.props.location !== 'exchange' ) && (!this.props.cancelActive || this.props.currentUser.cancelPermission) && this.props.selectedItem.cancelled !== 1 && !(this.props.selectedItem.processState < 140 && this.props.selectedItem.processResult === 3) &&
								hasUserRight((this.props.documentType === "MUSTAHSILMAKBUZ") ? UserRightsEnum.voucher.mmUpdate : UserRightsEnum.voucher.smmUpdate, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.cancelVoucher(this.props.selectedItem)}>Makbuzu İptal
										Et</a>
								</Col>}

								{this.props.documentType !== "RECEIPT" && (hasUserRight((this.props.documentType === "MUSTAHSILMAKBUZ") ? UserRightsEnum.voucher.mmCreate :
									(this.props.documentType === "SERBESTMESLEKMAKBUZ" ? UserRightsEnum.voucher.smmCreate : UserRightsEnum.exchange.create), this.props.currentUser)) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.copyEditVoucher(this.props.selectedItem, "copy")}>Makbuzu
										Kopyala</a>
								</Col>}
								{((this.props.documentType === "EDOVIZBELGE" && this.props.selectedItem.processState > 110) || (this.props.documentType === "MUSTAHSILMAKBUZ" && this.props.selectedItem.processState > 110) || (this.props.documentType === "SERBESTMESLEKMAKBUZ" && this.props.selectedItem.processState > 130)) &&
								hasUserRight((this.props.documentType === "MUSTAHSILMAKBUZ") ? UserRightsEnum.voucher.mmView : UserRightsEnum.voucher.smmView, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.sendEmail(this.props.selectedItem)}>e-Posta Gönder</a>
								</Col>}
								{showSmmRepeatDay(this.props.documentType) &&
								hasUserRight(UserRightsEnum.voucher.smmCreate, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.repeatMonthly(this.props.selectedItem)}>Aylık
										Tekrarla</a>
								</Col>}

								{(this.props.documentType === "SERBESTMESLEKMAKBUZ" &&
										this.props.selectedItem.processState === 140 &&
										!this.props.selectedItem.dbsId &&
										showDbs()) &&
								hasUserRight(UserRightsEnum.voucher.smmUpdate, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.saveToDbs(this.props.selectedItem)}>DBS'ye Kaydet</a>
								</Col>}
								{(this.props.documentType === "MUSTAHSILMAKBUZ" || this.props.documentType === "SERBESTMESLEKMAKBUZ") &&
									hasUserRight((this.props.documentType === "MUSTAHSILMAKBUZ") ? UserRightsEnum.voucher.mmCreate : UserRightsEnum.voucher.smmCreate, this.props.currentUser) &&
									<Col xs='6' md='4' lg='2'>
										<a className='btn-info' onClick={() => this.downloadArchiveVoucherPdf()} >Pdf İndir</a>
									</Col>}
								
								{(this.props.documentType === "SERBESTMESLEKMAKBUZ" &&
										this.props.selectedItem.processState === 140 &&
										this.props.selectedItem.dbsId &&
										hasUserRight(UserRightsEnum.voucher.smmUpdate, this.props.currentUser) &&
										showDbs()) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.delete(this.props.selectedItem.recordId)}>DBS'den
										Sil</a>
								</Col>}

								{this.props.selectedItem.cancelled === 1 && this.props.selectedItem.cancelReportNo === null &&
								hasUserRight((this.props.documentType === "MUSTAHSILMAKBUZ") ? UserRightsEnum.voucher.mmUpdate : UserRightsEnum.voucher.smmUpdate, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.revertCancelVoucher(this.props.selectedItem)}>Makbuz
										İptalini Geri Al</a>
								</Col>}
							</Row>}

							{(this.props.selectedItem && this.props.currentUser && this.props.location === 'voucherT') &&
							<Row className='viewer-button-row'>
								{((this.props.direction === "Out" && (this.props.selectedItem.eState === 1)) || this.props.direction === "Tmp") &&
								hasUserRight((this.props.type === "MM") ? UserRightsEnum.voucher.mmSend : (this.props.type === "SMM" ? UserRightsEnum.voucher.smmSend : UserRightsEnum.exchange.send), this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.handleSend(this.props.selectedItem, this.props.selectedIndex)}>Makbuzu
										Gönder</a>
								</Col>}

								{hasUserRight((this.props.type === "MM") ? UserRightsEnum.voucher.mmUpdate : (this.props.type === "SMM" ? UserRightsEnum.voucher.smmUpdate : UserRightsEnum.exchange.update), this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.handleEdit(this.props.selectedItem)}>Makbuzu Düzenle</a>
								</Col>}

								{((this.props.direction === "Out" && (this.props.selectedItem.eState !== 0)) || this.props.direction === "Tmp") &&
								hasUserRight((this.props.type === "MM") ? UserRightsEnum.voucher.mmView : (this.props.type === "SMM" ? UserRightsEnum.voucher.smmView : UserRightsEnum.exchange.view), this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.downloadMedia(this.props.selectedItem, "xml")}>Makbuz
										XML İndir</a>
								</Col>}

								{hasUserRight((this.props.type === "MM") ? UserRightsEnum.voucher.mmDelete : (this.props.type === "SMM" ?  UserRightsEnum.voucher.smmDelete : UserRightsEnum.exchange.delete), this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.handleDelete(this.props.selectedItem)}>Makbuzu Sil</a>
								</Col>}
							</Row>}

							{(this.props.selectedItem && this.props.currentUser && this.props.location === 'despatch') &&
							<Row className='viewer-button-row'>
								{((this.props.name === "despatchOutboxes" && (this.props.selectedItem.eState === 1)) || this.props.name === "despatches") &&
								hasUserRight(UserRightsEnum.despatch.send, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.handleSend(this.props.selectedItem, this.props.selectedIndex)}>İrsaliye
										Gönder</a>
								</Col>}

								{hasUserRight(UserRightsEnum.despatch.update, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.handleEdit(this.props.selectedItem)}>İrsaliye
										Düzenle</a>
								</Col>}

								{((this.props.name === "despatchOutboxes" && (this.props.selectedItem.eState !== 0)) || this.props.name === "despatches") &&
								hasUserRight(UserRightsEnum.despatch.view, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.downloadMedia(this.props.selectedItem, "xml")}>İrsaliye
										XML İndir</a>
								</Col>}

								{hasUserRight(UserRightsEnum.despatch.delete, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.handleDelete(this.props.selectedItem)}>İrsaliye Sil</a>
								</Col>}
							</Row>}

							{(this.props.selectedItem && this.props.currentUser && (this.props.location === 'TmpSigorta' || this.props.location === 'sigorta')) &&
								<Row className='viewer-button-row'>
									{(this.props.location === 'TmpSigorta' && hasUserRight(UserRightsEnum.sigorta.send, this.props.currentUser)) &&
										<Col xs='6' md='4' lg='2'>
											<a className='btn-info' onClick={() => this.props.handleSend(this.props.selectedItem)}>Sigortayı Gönder</a>
										</Col>}

									{(this.props.location === 'TmpSigorta' && hasUserRight(UserRightsEnum.sigorta.update, this.props.currentUser)) &&
										<Col xs='6' md='4' lg='2'>
											<a className='btn-info' onClick={() => this.props.handleEdit(this.props.selectedItem)}>Sigortayı Düzenle</a>
										</Col>}

									{(hasUserRight(UserRightsEnum.sigorta.view, this.props.currentUser)) &&
										<Col xs='6' md='4' lg='2'>
											<a className='btn-info' onClick={() => this.props.downloadMedia(this.props.selectedItem, "xml")}>Sigorta XML İndir</a>
										</Col>}

									{(this.props.location === 'TmpSigorta' && hasUserRight(UserRightsEnum.sigorta.delete, this.props.currentUser)) &&
										<Col xs='6' md='4' lg='2'>
											<a className='btn-info' onClick={() => this.props.handleDelete(this.props.selectedItem)}>Sigortayı Sil</a>
										</Col>}
									{(this.props.location !== 'TmpSigorta' && hasUserRight(UserRightsEnum.sigorta.create, this.props.currentUser)) &&
										<Col xs='6' md='4' lg='2'>
											<a className='btn-info' onClick={() => this.props.copyEditSigorta(this.props.selectedItem, "copy")}>Sigortayı
												Kopyala</a>
										</Col>
									}
								</Row>}

							{(this.props.selectedItem && this.props.currentUser && this.props.location === 'despatchOutbox') &&
							<Row className='viewer-button-row'>
								{((this.props.stateCodes instanceof Object && ((this.props.selectedItem.processState +
										"" + this.props.selectedItem.processResult) in this.props.stateCodes)) &&
										this.props.selectedItem.processResult !== 1181 &&
										(this.props.stateCodes[this.props.selectedItem.processState +
										"" + this.props.selectedItem.processResult][1] === "F")) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.copyEditDespatch(this.props.selectedItem, "edit")}>İrsaliye
										Düzenle</a>
								</Col>}

								{this.props.selectedItem.processState > 100 &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.additionalDocuments(this.props.selectedItem)}>Ek
										Dokümanlar</a>
								</Col>}

								{this.props.selectedItem.processState > 100 &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.downloadMedia(this.props.selectedItem, "xml")}>İrsaliye
										XML İndir</a>
								</Col>}


								{(this.props.selectedItem.responseDocumentUuid !== "OTOMATIK KABUL" && this.props.selectedItem.responseDocumentUuid) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.downloadMedia(this.props.selectedItem, "response_xml")}>İrs.
										Ynt. XML İndir</a>
								</Col>}

								{(this.props.selectedItem.responseDocumentUuid !== "OTOMATIK KABUL" && this.props.selectedItem.responseDocumentUuid) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.downloadMedia(this.props.selectedItem, "response_pdf")}>İrs.
										Ynt. Göster</a>
								</Col>}

								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.copyEditDespatch(this.props.selectedItem, "copy")}>İrsaliye
										Kopyala</a>
								</Col>

								{this.props.selectedItem.processState >= 100 &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.sendEmail(this.props.selectedItem)}>e-Posta Gönder</a>
								</Col>}

								{(this.props.selectedItem.processState === 500 && this.props.selectedItem.processResult === 1300) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.checkDespatchInvoiced([this.props.selectedItem])}>Faturalandır</a>
								</Col>}

								{this.props.selectedItem.processState > 180 &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.queryDespatch(this.props.selectedItem)}>Zarf
										Sorgula</a>
								</Col>}

								{(this.props.selectedItem.processState === 140 && this.props.selectedItem.processResult === 3) ||
								(this.props.selectedItem.processState === 180 && this.props.selectedItem.processResult === 3) ||
								(this.props.selectedItem.processState === 500 && (this.props.selectedItem.processResult === 1181 ||
												// this.props.selectedItem.processResult === 1195 ||
												this.props.selectedItem.processResult === 1162 ||
												this.props.selectedItem.processResult === 1120 ||
												this.props.selectedItem.processResult === 1130 ||
												this.props.selectedItem.processResult === 1140 ||
												this.props.selectedItem.processResult === 1215 ||
												this.props.selectedItem.processResult === 1230 ||
												this.props.selectedItem.processResult === 1160 ||
												this.props.selectedItem.processResult === 1176 ||
												this.props.selectedItem.processResult === 1177)
								) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.reSendDespatch(this.props.selectedItem)}>Tekrar
										Gönder</a>
								</Col>}

								{(this.props.selectedItem.processState === 500 &&
										(this.props.selectedItem.processResult === 1140 ||
											this.props.selectedItem.processResult === 1181 ||
											this.props.selectedItem.processResult === 1171 ||
											this.props.selectedItem.processResult === 1172 ||
											this.props.selectedItem.processResult === 1173 ||
											this.props.selectedItem.processResult === 1174)) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.editAlias(this.props.selectedItem)}>Etiketi Düzenle</a>
								</Col>}

								{this.props.selectedItem.processState > 100 &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={()=> this.printDocument()} >Pdf Yazdır</a>
								</Col>
								}
								{this.props.selectedItem.processState > 100 &&
									<Col xs='6' md='4' lg='2'>
										<a className='btn-info' onClick={() => this.downloadDespatchOutboxPdf()} >Pdf İndir</a>
									</Col>
								}
							</Row>}

							{(this.props.selectedItem && this.props.currentUser && this.props.location === 'despatchInbox') &&
							<Row className='viewer-button-row'>

								{(this.props.selectedItem.responseValidationState !== 1 && this.props.selectedItem.responseValidationState !== 2) &&
								hasUserRight(UserRightsEnum.despatch.respondIncoming, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.replyDespatch(this.props.selectedItem)}>İrsaliye
										Cevapla</a>
								</Col>}

								{hasUserRight(UserRightsEnum.despatch.viewIncoming, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.additionalDocuments(this.props.selectedItem)}>Ek Dokümanlar</a>
								</Col>}

								{hasUserRight(UserRightsEnum.despatch.viewIncoming, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.downloadMedia(this.props.selectedItem, "xml")}>İrsaliye XML İndir</a>
								</Col>}

								{(this.props.selectedItem.responseDocumentUuid !== "OTOMATIK KABUL" && this.props.selectedItem.responseDocumentUuid) &&
								hasUserRight(UserRightsEnum.despatch.viewIncoming, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.downloadMedia(this.props.selectedItem, "response_xml")}>İrs.
										Ynt. XML İndir</a>
								</Col>}

								{hasUserRight(UserRightsEnum.despatch.viewIncoming, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.sendEmail(this.props.selectedItem)}>e-Posta Gönder</a>
								</Col>}

								{hasUserRight(UserRightsEnum.despatch.viewIncoming, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={() => this.props.createExtCust(this.props.selectedItem)}>Cari Oluştur</a>
								</Col>}

								{hasUserRight(UserRightsEnum.despatch.viewIncoming, this.props.currentUser) &&
								<Col xs='6' md='4' lg='2'>
									<a className='btn-info' onClick={()=> this.printDocument()} >Pdf Yazdır</a>
								</Col>
								}
								{hasUserRight(UserRightsEnum.invoice.viewIncoming, this.props.currentUser) &&
									<Col xs='6' md='4' lg='2'>
										<a className='btn-info' onClick={() => this.downloadDespatchInboxPdf()} >Pdf İndir</a>
									</Col>
								}
							</Row>}

							<div className="col-sm-12" style={{marginTop: "2px", marginBottom: "2px", top: 0, left: 0}}>
								{this.props.url &&
								<iframe src={this.props.url} style={{
									top: 0,
									left: 0,
									width: "100%",
									height: (this.state.changeSize ? "677px" : "600px")
								}}/>}
								{!this.props.url && "Yükleniyor..."}
							</div>

							{ this.state.printViewer &&
								<PrintViewer url={this.props.url} close={this.closePrintModal}/>
							}


						</Modal.Body>
					</Modal>
				</div>
		);
	}

}

export default MediaViewer;